import template from './index.html'
import controller from './controller'

partDetailOrders.vsName = 'partDetailOrders'
partDetailOrders.vsNgType = 'directive'

partDetailOrders.$inject = []
function partDetailOrders() {
  return {
    restrict: 'E',
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: template,
    scope: {
      part: '='
    }
  }
}

export default partDetailOrders